import React from 'react';
import { useSwipeable } from 'react-swipeable';

const SwipeComponent = (props) => {
  const handlers = useSwipeable({
    onSwipedLeft: () => {
      props.onSwipedLeft();
    },
    onSwipedRight: () => {
      props.onSwipedRight();
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  return (
    <div {...handlers} className="h-100">
      <div className="h-100" style={{overflow:'hidden'}}>{props.children}</div>
    </div>
  );
};
export default SwipeComponent;
